export default __webpack_public_path__ + "static/media/image-study-board-1-m@3x.f5cb6033.png";